import {Form, Input} from 'antd';
import React, {FC} from 'react';

import {requiredInputRule} from '../../utils';

export const FinancialIndicators: FC = () => (
    <>
        <div className="form-financial-indicators project-item-block">
            <Form.Item
                name={['financialIndicators', 'finTotalAmount']}
                label="Общий плановый объем финансирования инвестиционного проекта, включая собственные и
            привлеченные средства, за все годы (в рублях), в том числе:"
                rules={[requiredInputRule()]}
            >
                <Input type="number" placeholder="Введите значение" autoComplete="off" />
            </Form.Item>
            <div className="padding-block">
                <Form.Item
                    name={['financialIndicators', 'finConstructionSiteAmount']}
                    label="строительство (за все годы)"
                    rules={[requiredInputRule()]}
                >
                    <Input type="number" placeholder="Введите значение" autoComplete="off" />
                </Form.Item>
                <Form.Item
                    name={['financialIndicators', 'finReconstructionAmount']}
                    label="реконструкция (за все годы)"
                    rules={[requiredInputRule()]}
                >
                    <Input type="number" placeholder="Введите значение" autoComplete="off" />
                </Form.Item>
                <Form.Item
                    name={['financialIndicators', 'finTechUpgradeAmount']}
                    label="техническое перевооружение действующих предприятий (за все годы)"
                    rules={[requiredInputRule()]}
                >
                    <Input type="number" placeholder="Введите значение" autoComplete="off" />
                </Form.Item>
                <Form.Item
                    name={['financialIndicators', 'finAssetModernAmount']}
                    label="модернизация основных средств (за все годы)"
                    rules={[requiredInputRule()]}
                >
                    <Input type="number" placeholder="Введите значение" autoComplete="off" />
                </Form.Item>
            </div>
        </div>
        <div className="form-financial-indicators out-block-element">
            <Form.Item
                name={['financialIndicators', 'finTaxpayerSum']}
                label="	Плановый объем финансирования из собственных средств НП из общего планового объема
            финансирования, за все годы (в рублях)"
                rules={[requiredInputRule()]}
            >
                <Input type="number" placeholder="Введите значение" autoComplete="off" />
            </Form.Item>
        </div>
        <div className="form-financial-indicators project-item-block">
            <Form.Item
                name={['financialIndicators', 'planInvestTotal']}
                label="	Общий объем планируемых из собственных и привлеченных средств затрат на создание
                (приобретение) амортизируемого имущества в рублях (за все годы)"
                rules={[requiredInputRule()]}
            >
                <Input type="number" placeholder="Введите значение" autoComplete="off" />
            </Form.Item>
            <div className="padding-block">
                <Form.Item
                    name={['financialIndicators', 'planInvestSmrSum']}
                    label="планируемые затраты на строительно-монтажные работы (за все годы)"
                    rules={[requiredInputRule()]}
                >
                    <Input type="number" placeholder="Введите значение" autoComplete="off" />
                </Form.Item>
                <Form.Item
                    name={['financialIndicators', 'planInvestEquipmentSum']}
                    label="затраты на машины, оборудование, инструменты, инвентарь (за все годы)"
                    rules={[requiredInputRule()]}
                >
                    <Input type="number" placeholder="Введите значение" autoComplete="off" />
                </Form.Item>
                <Form.Item
                    name={['financialIndicators', 'planInvestOtherSum']}
                    label="прочие затраты (за все годы)"
                    rules={[requiredInputRule()]}
                >
                    <Input type="number" placeholder="Введите значение" autoComplete="off" />
                </Form.Item>
                <div className="padding-block additional-padding-block">
                    <Form.Item
                        name={['financialIndicators', 'planInvestPirSum']}
                        label="из них ПИР - проектно-изыскательские работы (за все годы)"
                        rules={[requiredInputRule()]}
                    >
                        <Input type="number" placeholder="Введите значение" autoComplete="off" />
                    </Form.Item>
                    <Form.Item
                        name={['financialIndicators', 'planInvestItSum']}
                        label="из них расходы на интеллектуальную деятельность (за все годы)"
                        rules={[requiredInputRule()]}
                    >
                        <Input type="number" placeholder="Введите значение" autoComplete="off" />
                    </Form.Item>
                </div>
            </div>
        </div>
        <div className="form-financial-indicators project-item-block">
            <Form.Item
                name={['financialIndicators', 'factYearInvestTotal']}
                label="Общий объем осуществленных затрат на создание (приобретение)
                амортизируемого имущества за отчетный год в рублях:"
                rules={[requiredInputRule()]}
            >
                <Input type="number" placeholder="Введите значение" autoComplete="off" />
            </Form.Item>
            <div className="padding-block">
                <Form.Item
                    name={['financialIndicators', 'factYearInvestSmrSum']}
                    label="затраты отчетного года на строительно-монтажные работы (за отчетный год)"
                    rules={[requiredInputRule()]}
                >
                    <Input type="number" placeholder="Введите значение" autoComplete="off" />
                </Form.Item>
                <Form.Item
                    name={['financialIndicators', 'factYearInvestEquipmentSum']}
                    label="затраты отчетного года на машины, оборудование, инструменты, инвентарь (за отчетный год)"
                    rules={[requiredInputRule()]}
                >
                    <Input type="number" placeholder="Введите значение" autoComplete="off" />
                </Form.Item>
                <Form.Item
                    name={['financialIndicators', 'factYearInvestOtherSum']}
                    label="прочие затраты отчетного года (за отчетный год)"
                    rules={[requiredInputRule()]}
                >
                    <Input type="number" placeholder="Введите значение" autoComplete="off" />
                </Form.Item>
                <div className="padding-block additional-padding-block">
                    <Form.Item
                        name={['financialIndicators', 'factYearInvestPirSum']}
                        label="из них ПИР - проектно-изыскательские работы (за отчетный год)"
                        rules={[requiredInputRule()]}
                    >
                        <Input type="number" placeholder="Введите значение" autoComplete="off" />
                    </Form.Item>
                    <Form.Item
                        name={['financialIndicators', 'factYearInvestItSum']}
                        label="из них расходы на интеллектуальную деятельность (за отчетный год)"
                        rules={[requiredInputRule()]}
                    >
                        <Input type="number" placeholder="Введите значение" autoComplete="off" />
                    </Form.Item>
                </div>
            </div>
        </div>
        <div className="form-financial-indicators project-item-block">
            <Form.Item
                name={['financialIndicators', 'factInvestTotal']}
                label="Общий объем осуществленных затрат на создание (приобретение)
                амортизируемого имущества в рублях (за все годы):"
                rules={[requiredInputRule()]}
            >
                <Input type="number" placeholder="Введите значение" autoComplete="off" />
            </Form.Item>
            <div className="padding-block">
                <Form.Item
                    name={['financialIndicators', 'factInvestSmrSum']}
                    label="затраты на строительно-монтажные работы (за все годы)"
                    rules={[requiredInputRule()]}
                >
                    <Input type="number" placeholder="Введите значение" autoComplete="off" />
                </Form.Item>
                <Form.Item
                    name={['financialIndicators', 'factInvestEquipmentSum']}
                    label="затраты на машины, оборудование, инструменты, инвентарь (за все годы)"
                    rules={[requiredInputRule()]}
                >
                    <Input type="number" placeholder="Введите значение" autoComplete="off" />
                </Form.Item>
                <Form.Item
                    name={['financialIndicators', 'factInvestOtherSum']}
                    label="прочие затраты (за все годы)"
                    rules={[requiredInputRule()]}
                >
                    <Input type="number" placeholder="Введите значение" autoComplete="off" />
                </Form.Item>
                <div className="padding-block additional-padding-block">
                    <Form.Item
                        name={['financialIndicators', 'factInvestPirSum']}
                        label="из них ПИР - проектно-изыскательские работы (за все годы)"
                        rules={[requiredInputRule()]}
                    >
                        <Input type="number" placeholder="Введите значение" autoComplete="off" />
                    </Form.Item>
                    <Form.Item
                        name={['financialIndicators', 'factInvestItSum']}
                        label="из них расходы на интеллектуальную деятельность (за все годы)"
                        rules={[requiredInputRule()]}
                    >
                        <Input type="number" placeholder="Введите значение" autoComplete="off" />
                    </Form.Item>
                </div>
            </div>
        </div>
        <div className="form-financial-indicators project-item-block">
            <Form.Item
                name={['financialIndicators', 'planned1YearInvestSum']}
                label="График планового объема капитальных вложений: 1-й год
                        (следующий после отчетного), руб."
                rules={[requiredInputRule()]}
            >
                <Input type="number" placeholder="Введите значение" autoComplete="off" />
            </Form.Item>
            <Form.Item
                name={['financialIndicators', 'planned2YearInvestSum']}
                label="График планового объема капитальных вложений: 2-й год, руб."
                rules={[requiredInputRule()]}
            >
                <Input type="number" placeholder="Введите значение" autoComplete="off" />
            </Form.Item>
            <Form.Item
                name={['financialIndicators', 'planned3YearInvestSum']}
                label="График планового объема капитальных вложений: 3-й год, руб."
                rules={[requiredInputRule()]}
            >
                <Input type="number" placeholder="Введите значение" autoComplete="off" />
            </Form.Item>
            <Form.Item
                name={['financialIndicators', 'planned4YearInvestSum']}
                label="График планового объема капитальных вложений: 4-й год, руб."
                rules={[requiredInputRule()]}
            >
                <Input type="number" placeholder="Введите значение" autoComplete="off" />
            </Form.Item>
            <Form.Item
                name={['financialIndicators', 'planned5YearInvestSum']}
                label="График планового объема капитальных вложений: 5-й и последующие годы (сумма), руб."
                rules={[requiredInputRule()]}
            >
                <Input type="number" placeholder="Введите значение" autoComplete="off" />
            </Form.Item>
        </div>
    </>
);

